import { removeEmployee, editEmployee, addEmployee } from '@api/employees/employees.service';
import { EditEmployeeRequest, AddEmployeeRequest } from '@interfaces/models';
import { ResponseErrorDto } from '@interfaces/models';
import { useMutation } from '@tanstack/react-query';

export const useEmployees = ({
  onRemoveSuccess = () => {},
  onRemoveError = () => {},
  onAddSuccess = () => {},
  onAddError = () => {},
  onEditSuccess = () => {},
  onEditError = () => {},
}: {
  onRemoveError?: ({ error }: { error: ResponseErrorDto }) => void;
  onEditError?: ({ error }: { error: ResponseErrorDto }) => void;
  onAddError?: ({ error }: { error: ResponseErrorDto }) => void;
  onRemoveSuccess?: () => void;
  onEditSuccess?: () => void;
  onAddSuccess?: () => void;
}) => {
  const { mutate: mutateRemoveEmployee, isPending: isRemoveEmployeePending } = useMutation({
    mutationFn: (employeeId: string) => removeEmployee(employeeId),
    onSuccess: onRemoveSuccess,
    onError: onRemoveError,
  });

  const { mutate: mutateAddEmployee, isPending: isAddEmployeePending } = useMutation({
    mutationFn: (employee: AddEmployeeRequest) => addEmployee(employee),
    onSuccess: onAddSuccess,
    onError: onAddError,
  });

  const { mutate: mutateEditEmployee, isPending: isEditEmployeePending } = useMutation({
    mutationFn: ({ employee, id }: { employee: EditEmployeeRequest; id: string }) =>
      editEmployee(employee, id),
    onSuccess: onEditSuccess,
    onError: onEditError,
  });

  return {
    mutateRemoveEmployee,
    isRemoveEmployeePending,
    mutateAddEmployee,
    isAddEmployeePending,
    mutateEditEmployee,
    isEditEmployeePending,
  };
};
